module.exports = __webpack_public_path__ + "static/img/4b.3569941.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/4b.jpg
// module id = Awlu
// module chunks = 1